import { NgModule } from '@angular/core';
import { SharedProviderModule } from '../shared/shared.module';
import { NgbDropdownModule, NgbPaginationModule, NgbNavModule, NgbTypeaheadModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { VivoListComponent } from './vivo-list/vivo-list.component';
import { VivoMaintenanceComponent } from './vivo-maintenance/vivo-maintenance.component';
import { ElementUtilsModule } from '../element-utils/element-utils.module';
import { VivoFiltersModule } from '../sidebar/vivo-filters/vivo-filters.module';
import { VivoService } from './vivo.service';
import { NotificationModule } from '~app/components/notification/notification.module';

@NgModule({
  imports: [
    SharedProviderModule,
    ElementUtilsModule,
    VivoFiltersModule,
    NotificationModule,
    NgbTypeaheadModule,
    NgbNavModule,
    NgbDropdownModule,
    NgbPaginationModule,
    NgbTooltipModule
  ],
  declarations: [VivoListComponent, VivoMaintenanceComponent],
  exports: [VivoListComponent, VivoMaintenanceComponent],
  providers: [VivoService],
})
export class VivoModule { }
